import { create } from "zustand";
import { createJSONStorage, persist, subscribeWithSelector } from "zustand/middleware";
import { CustomerInfoSlice, createCustomerInfoSlice } from "./slices/customerInfo";
import { createDeviceInfoSlice, DeviceInfoSlice } from "./slices/deviceInfo";
import { createPartnerConfigSlice, PartnerConfigSlice } from "./slices/partnerConfig";
import { createSessionSlice, SessionInfoSlice } from "./slices/sessionInfo";
export type Storage = SessionInfoSlice & CustomerInfoSlice & PartnerConfigSlice & DeviceInfoSlice;

export const useStore = create<Storage>()(
	subscribeWithSelector(
		persist(
			(...a) => ({
				...createSessionSlice(...a),
				...createCustomerInfoSlice(...a),
				...createPartnerConfigSlice(...a),
				...createDeviceInfoSlice(...a),
			}),
			{ name: "store", storage: createJSONStorage(() => sessionStorage) },
		),
	),
);
